<template>
  <div class="step-meeting-type">
    <h2 class="step-meeting-type__title">Como deseja realizar a consulta?</h2>
    <p v-if="service" class="step-meeting-type__subtitle">
      <strong>{{ service.name }}</strong>
      <span v-if="meetingDurationText" class="step-meeting-type__duration">
        <i class="pi pi-clock" /> {{ meetingDurationText }}
      </span>
    </p>
    <p class="step-meeting-type__hint">
      Escolha entre videoconferência ou deslocação ao escritório.
    </p>

    <div class="step-confirm__payment-options meeting-mode-options">
      <div
        class="payment-option meeting-mode-option"
        :class="{ 'payment-option--selected': modelValue === 'online' }"
        role="button"
        tabindex="0"
        @click="selectOnline"
        @keydown.enter.prevent="selectOnline"
        @keydown.space.prevent="selectOnline"
      >
        <i class="pi pi-video" />
        <div class="meeting-mode-option__text">
          <span class="meeting-mode-option__label">Online</span>
          <small class="meeting-mode-option__desc"
            >Videoconferência no horário agendado</small
          >
        </div>
      </div>
      <div
        v-for="office in officeOptions"
        :key="office.id"
        class="payment-option meeting-mode-option"
        :class="{
          'payment-option--selected':
            modelValue === 'on-site' &&
            Number(selectedOfficeId) === Number(office.id),
        }"
        role="button"
        tabindex="0"
        @click="selectOnSiteOffice(office.id)"
        @keydown.enter.prevent="selectOnSiteOffice(office.id)"
        @keydown.space.prevent="selectOnSiteOffice(office.id)"
      >
        <i class="pi pi-map-marker" />
        <div class="meeting-mode-option__text">
          <span class="meeting-mode-option__label">{{ office.label }}</span>
          <small class="meeting-mode-option__desc">Presencial</small>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AppointmentStepMeetingType",
  props: {
    service: { type: Object, required: true },
    modelValue: { type: String, default: null },
    officeOptions: {
      type: Array,
      default: function () {
        return [];
      },
    },
    selectedOfficeId: { type: Number, default: null },
  },
  emits: ["update:modelValue", "valid", "office-selected"],
  computed: {
    meetingDurationText() {
      if (!this.service || !this.service.meetingDuration) return "";
      return this.formatDuration(this.service.meetingDuration);
    },
  },
  watch: {
    modelValue: {
      immediate: true,
      handler(v) {
        if (v === "online") {
          this.$emit("valid", true);
          return;
        }
        if (v === "on-site") {
          this.$emit("valid", this.selectedOfficeId != null);
          return;
        }
        this.$emit("valid", false);
      },
    },
    selectedOfficeId() {
      if (this.modelValue === "on-site") {
        this.$emit("valid", this.selectedOfficeId != null);
      }
    },
  },
  methods: {
    selectOnline() {
      this.$emit("office-selected", null);
      if (this.modelValue !== "online") {
        this.$emit("update:modelValue", "online");
      }
      this.$emit("valid", true);
    },
    selectOnSiteOffice(officeId) {
      this.$emit("office-selected", Number(officeId));
      if (this.modelValue !== "on-site") {
        this.$emit("update:modelValue", "on-site");
      }
      this.$emit("valid", true);
    },
    formatDuration(duration) {
      if (!duration) return "";
      const d = String(duration);
      if (d === "00:00:00") return "";
      let h = 0;
      let m = 0;
      const isoMatch = d.match(/T(\d{2}):(\d{2}):(\d{2})/);
      if (isoMatch) {
        h = parseInt(isoMatch[1], 10);
        m = parseInt(isoMatch[2], 10);
      } else {
        const parts = d.split(":");
        h = parseInt(parts[0], 10);
        m = parseInt(parts[1], 10);
      }
      if (isNaN(h) || isNaN(m)) return "";
      if (h === 0 && m === 0) return "";
      if (h > 0 && m > 0) return h + "h " + m + "min";
      if (h > 0) return h + "h";
      return m + "min";
    },
  },
};
</script>
